import { FormControl } from 'baseui/form-control'
import { ModalBody, ModalButton, ModalFooter } from 'baseui/modal'
import { ArrowRight } from 'baseui/icon'
import { Spinner } from 'baseui/spinner'
import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import { SIZE } from 'baseui/input'
import usePdlSearchV2 from './usePdlSearchV2'
import useRetrievePDLsV2 from './useRetrievePDLsV2'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDButtonGroup from '@/shared/components/SDComponents/SDButtonGroup/SDButtonGroup'
import SDButtonGroupButton from '@/shared/components/SDComponents/SDButtonGroup/SDButtonGroupButton'
import AddressSelect from '@/containers/SubscriptionFormPageNew/Components/shared/AddressSelect/AddressSelect'
import { Input } from 'baseui/input'

const PdlSearchForm = () => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const {
    getAddress,
    getOccupant,
    getStreetNumber,
    getStreetName,
    getMatricule,
    getComplement,
    getBuilding,
    getLocality,
    getContractType,
    isAddressFilled,
    isLoading,
    updatePdlConfigData,
    updateAddressHandler,
  } = usePdlSearchV2()
  const { searchPDLs } = useRetrievePDLsV2()

  return (
    <>
      <ModalBody>
        <div className={css({ padding: '1rem 0' })}>
          <AddressSelect
            currentValue={getAddress}
            onChange={updateAddressHandler}
            disabled={isLoading}
            placeholder={t('subscriptionTools:pdl_search.fields.address')}
          />
          <div
            className={css({
              display: 'flex',
              gap: '1rem',
              alignItems: 'center',
              marginBottom: '1rem',
            })}
          >
            <div
              className={css({
                flex: '1 1 30%',
              })}
            >
              <Input
                value={getStreetNumber}
                onChange={e => updatePdlConfigData({ address: { ...getAddress, streetNumber: e.target.value } })}
                placeholder={t('subscriptionForm:address_module.street_number')}
              />
            </div>
            <div
              className={css({
                flex: '1 1 70%',
              })}
            >
              <Input
                value={getStreetName}
                onChange={e => updatePdlConfigData({ address: { ...getAddress, streetName: e.target.value } })}
                placeholder={t('subscriptionForm:address_module.street_name')}
              />
            </div>
          </div>

          <FormControl>
            <SDInput
              placeholder={t('subscriptionTools:pdl_search.fields.occupant')}
              currentValue={getOccupant}
              onBlur={value => updatePdlConfigData({ occupant: value || '' })}
              disabled={isLoading}
            />
          </FormControl>

          <FormControl>
            <SDInput
              placeholder={t('subscriptionTools:pdl_search.fields.complement')}
              currentValue={getComplement}
              onBlur={value => updatePdlConfigData({ complement: value || '' })}
              disabled={isLoading}
            />
          </FormControl>

          <div className={css({ display: 'flex', gap: '0.5rem' })}>
            <div className={css({ flex: 1 })}>
              <SDInput
                placeholder={t('subscriptionTools:pdl_search.fields.building')}
                currentValue={getBuilding}
                onBlur={value => updatePdlConfigData({ building: value || '' })}
                disabled={isLoading}
              />
            </div>
            <div className={css({ flex: 1 })}>
              <SDInput
                placeholder={t('subscriptionTools:pdl_search.fields.locality')}
                currentValue={getLocality}
                onBlur={value => updatePdlConfigData({ locality: value })}
                disabled={isLoading}
              />
            </div>
          </div>

          <div className={css({ display: 'flex', gap: '0.5rem', marginTop: '1rem' })}>
            <div className={css({ flex: 1 })}>
              <SDInput
                placeholder={t('subscriptionTools:pdl_search.fields.serial_number')}
                currentValue={getMatricule}
                onBlur={value => updatePdlConfigData({ matricule: value })}
                disabled={isLoading}
              />
            </div>
          </div>

          <div className={css({ marginTop: '1rem' })}>
            <SDButtonGroup size={SIZE.mini} selected={getContractType === 'pro' ? [1] : [0]} disabled={isLoading}>
              <SDButtonGroupButton onClick={() => updatePdlConfigData({ contractType: 'part' })}>
                {t('subscriptionTools:pdl_search.fields.contract_type_part')}
              </SDButtonGroupButton>
              <SDButtonGroupButton onClick={() => updatePdlConfigData({ contractType: 'pro' })}>
                {t('subscriptionTools:pdl_search.fields.contract_type_pro')}
              </SDButtonGroupButton>
            </SDButtonGroup>
          </div>
        </div>
      </ModalBody>

      <ModalFooter
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#f7f7f7',
          borderTop: '0.0625rem solid #e0e0e0',
          padding: '1rem 1.5rem',
        }}
      >
        <ModalButton
          id='button-start-search'
          endEnhancer={() => <ArrowRight size={24} />}
          disabled={!isAddressFilled || isLoading}
          onClick={searchPDLs}
        >
          {t('subscriptionTools:pdl_search.start_search')}
        </ModalButton>
        {isLoading && <Spinner size={24} />}
      </ModalFooter>
    </>
  )
}

export default PdlSearchForm
